import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';

import { momentFormat } from '../../common/constants';
import { ApprovalStatus, ComponentDefinition, IApproval, IApprovalRow } from '../../models';

interface OnChangeArguments {
    approval: IApproval;
    row: IApprovalRow;
    status: ApprovalStatus;
    timestamp: Date;
}

class ApprovalStatusController implements angular.IComponentController {

    approval: IApproval;
    isClicked: boolean = false;
    label: string;
    maxLevel: number;
    onChange: (args: OnChangeArguments) => angular.IPromise<void>;
    row: any;

    readonly history: any[];
    readonly isApprovalDisabled: boolean;
    readonly isDisabled: boolean;
    readonly timestamp: Date;

    static $inject = [
        '$scope',
        '$translate'
    ];
    constructor(
        private _$scope: angular.IScope,
        private readonly _$translate: angular.translate.ITranslateService
    ) {
    }

    $onInit() {
        this._$scope.$watch(() => this.approval, data => {
            if (data) {
                this.initLabel();
            }
        });
    }

    getDate(): string {
        return this.formatDate(this.approval.approvedDate);
    }

    change(status: ApprovalStatus) {
        this.isClicked = true;
        const approval: OnChangeArguments = {
            approval: this.approval,
            status: status,
            timestamp: this.timestamp,
            row: this.row
        };
        this.onChange(approval)
            .finally(() => this.isClicked = false);
    }

    private initLabel() {
        let label = undefined;
        let msg: string;
        switch (this.approval.status) {
            case -1:
                const username = this.approval.user;
                msg = this._$translate.instant('Rejected by _user_ on _date_', { user: username, date: this.getDate() });
                if (this.approval.comment) {
                    msg = `${msg}\r\n${this.approval.comment}`;
                }
                label = msg;
                break;
            case 0: case 1:
                label = this._$translate.instant('Level') + String(this.approval.level + 1);
                break;
            case 2:
                const args = this.getApproved();
                msg = this._$translate.instant('Approved by _user_ on _date_', args);
                if (args.comment) {
                    msg = `${msg}\r\n${args.comment}`;
                }
                label = msg;
                break;
        }
        if (this.approval.manualComment) {
            label = `${this._$translate.instant(this.approval.manualComment)}\r\n${label}`;
        }
        this.label = label;
    }

    private formatDate(date: string): string {
        return moment(date).format(momentFormat);
    }

    private getApproved(): { user: string, date: string, comment: string } {
        const username = this.approval.user;
        let result = { user: username, date: this.getDate(), comment: this.approval.comment };
        if (this.history && this.history.length > 0) {
            const levelHistory = this.history.filter(h =>
                ((h.level - 1) === this.approval.level && h.status === 1) ||
                (this.maxLevel === this.approval.level && h.level === this.maxLevel)
            );

            if (levelHistory.length > 0) {
                const last = _.sortBy(levelHistory, (l: any) => l.approvedDate).reverse()[0];
                result = {
                    user: username,
                    date: this.formatDate(last.approvedDate),
                    comment: last.comment
                };
            }
        }

        return result;
    }
}

export const wtApprovalStatus: ComponentDefinition = {
    componentId: 'wtApprovalStatus',
    controller: ApprovalStatusController,
    template: require('./approvalStatus.component.html'),
    controllerAs: 'vm',
    bindings: {
        approval: '=',
        timestamp: '<?',
        history: '<?',
        onChange: '&',
        row: '=',
        maxLevel: '=',
        isDisabled: '<?',
        isApprovalDisabled: '<?',
        isDisplayOnly: '<'
    }
};